// src/components/AboutUs.jsx
import React from 'react';
import {
    FaMapMarkerAlt,
    FaPhoneAlt,
    FaIndustry,
    FaUsers,
    FaLinkedin,
    FaGlobe,
    FaBuilding,
    FaCalendarAlt
} from 'react-icons/fa';

export default function AboutUs() {
    return (
        <div className="bg-gray-50 text-gray-800">
            {/* Hero */}
            <div className="bg-gradient-to-r from-primary-500 to-secondary-500 text-white py-20 px-6 text-center">
                <h1 className="text-4xl md:text-5xl font-bold text-gray-50">About CareerConnect Ai</h1>
                <p className="mt-4 max-w-2xl mx-auto text-md md:text-lg text-slate-200">
                    CCAi ATS is a smart Applicant Tracking System built to simplify and speed up the entire hiring process.
                    It helps recruiters manage applications, screen candidates, schedule interviews, and track progress from start to finish — all in one streamlined platform.
                    With automated workflows, intelligent filtering, and real-time collaboration tools, it ensures faster hiring decisions and delivers a smooth experience for both candidates and recruitment teams.
                </p>
                <a
                    href="/signin"
                    target="_blank"
                    rel="noreferrer"
                    className="inline-block mt-6 px-8 py-3 bg-slate-100 text-slate-800 rounded-full font-medium hover:bg--slate-200 transition"
                >
                    Explore Features
                </a>
            </div>

            {/* Main Content */}
            <div className="max-w-7xl mx-auto px-6 py-16 space-y-16">
                {/* Overview */}
                <section className="space-y-6">
                    <h2 className="text-3xl font-semibold text-primary-400">Overview</h2>
                    <p className='font-medium text-slate-700'>
                        CCAi ATS is designed to streamline the entire recruitment workflow with precision, speed, and control. For hiring teams, the system offers structured job posting, automated resume screening, intelligent candidate ranking, and real-time collaboration across 
                        departments. For candidates, it ensures a transparent application experience, with status tracking and easy communication throughout the hiring journey.
                    </p>
                    <p className='font-medium text-slate-700'>
                        Built with a clean interface, modular architecture, and AI-powered decision support, CCAi ATS reduces manual effort and speeds up hiring cycles while improving
                         candidate quality. Whether you're a startup scaling your first team or an enterprise managing large-volume recruitment, CCAi ATS enables smarter hiring, consistent 
                         evaluation, and a more organized recruitment process from start to finish.
                    </p>
                </section>

                {/* Key Facts */}
                <section className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {[
                        {
                            icon: <FaMapMarkerAlt size={28} className="" />,
                            label: 'Headquarter',
                            value: 'Perundurai, Tamil Nadu'
                        },
                        {
                            icon: <FaPhoneAlt size={28} className="" />,
                            label: 'Phone',
                            value: '+91 63822 69679'
                        },
                        {
                            icon: <FaIndustry size={28} className="" />,
                            label: 'Industry',
                            value: 'IT & Engineering Services'
                        },
                        {
                            icon: <FaUsers size={28} className="" />,
                            label: 'Company Size',
                            value: '51–200 employees'
                        },
                        {
                            icon: <FaGlobe size={28} className="" />,
                            label: 'Branches',
                            value: '4'
                        },
                        {
                            icon: <FaCalendarAlt size={28} className="" />,
                            label: 'Founded',
                            value: '2017'
                        }
                    ].map((fact, idx) => (
                        <div
                            key={idx}
                            className="flex items-start gap-4 bg-white p-6 rounded-2xl shadow hover:shadow-lg transition"
                        >
                            <div className="p-3 bg-blue-50 text-primary-500 rounded-full">
                                {fact.icon}
                            </div>
                            <div>
                                <h4 className="text-xl font-semibold text-primary-500">{fact.label}</h4>
                                <p className="mt-1 font-medium text-slate-500">{fact.value}</p>
                            </div>
                        </div>
                    ))}
                </section>

                {/* Address Block */}
                <section className="bg-white p-6 rounded-2xl shadow-md flex flex-col md:flex-row items-start md:items-center gap-6">
                    <FaBuilding size={32} className="text-primary-500 flex-shrink-0" />
                    <div className="space-y-1">
                        <h3 className="text-2xl font-semibold text-primary-400 mb-3 cursor-pointer" onClick={() => window.open("https://www.sanengineeringsolutions.com/")}>Corporate Office</h3>
                        <address className="not-italic uppercase text-slate-700 text-sm cursor-pointer" onClick={() => window.open("https://www.sanengineeringsolutions.com/")}>
                            <b className='text-md'>SAN Engineering Solutions,</b><br />
                            2nd Floor, VSM Complex,<br />
                            Kanjikovil Road, Near Anna Silai,<br />
                            Perundurai – 638 052,<br />
                            Erode Dist., Tamil Nadu
                        </address>
                    </div>
                </section>
            </div>
        </div>
    );
}
